import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { Button, Stack } from '@forwardflow/ui-v2'
import { CheckCircle02Icon, Start02Icon } from '@forwardflow/icons'
import InboxAppIcon from '@forwardflow/assets/onboarding/installapplog.png'
import { useState } from 'react'

export const SetupInBoxApp = () => {
   const { goToStep, onboardingData, setInboxAppInstallRequest } =
      useOnboardingStoreV2()
   const [isInstalling, setIsInstalling] = useState(false)
   return (
      <Stack gap={32}>
         <div>
            <Stack
               align="center"
               className="p-6 text-center rounded-t-[16px] border border-b-0 border-white/15 bg-[linear-gradient(130deg,_rgba(255,255,255,0.05)_1.65%,_rgba(153,153,153,0.05)_100%)]"
            >
               <Start02Icon className="w-10 h-10 text-[#FB64B6]" />
               <p
                  className="font-semibold text-xl"
                  style={{
                     background:
                        'linear-gradient(90deg, #A684FF 0%, #FB64B6 100%)',
                     WebkitBackgroundClip: 'text',
                     WebkitTextFillColor: 'transparent',
                     backgroundClip: 'text',
                     color: 'transparent',
                  }}
               >
                  You have configured your first Campaign
               </p>
               <p className="text-white/70 text-sm max-w-md">
                  Your A2P registration is under way. This can take 7-10 days.
                  We will reach out to you as soon as its completed to launch
                  your campaigns!
               </p>
               <Button
                  size="large"
                  variant="secondary"
                  className="w-fit px-8"
                  onClick={() => goToStep('campaign-configuration')}
               >
                  Edit Campaign
               </Button>
            </Stack>
            <Stack
               align="center"
               className="p-6 text-center rounded-b-[16px] border border-[rgba(142,81,255,0.30)]"
               style={{
                  borderColor: 'rgba(142,81,255,0.30)',
                  background: 'rgba(179,126,243,0.05)',
               }}
            >
               <p className="text-white font-semibold text-xl">
                  Install Forward Flow Inbox App in Follow Up Boss?
               </p>
               <p className="text-white/70 text-sm max-w-md">
                  This lets you and your team view and monitor every
                  conversation Forward Flow has with your leads - directly
                  inside your FUB Inbox.
               </p>
               <Button
                  variant="secondary"
                  size="large"
                  className="w-fit px-8 bg-[#A684FF]/10 border-none transition-all duration-300"
                  onClick={() => {
                     if (!onboardingData?.inboxAppInstallRequest && !isInstalling) {
                        setIsInstalling(true)
                        setTimeout(() => {
                           setInboxAppInstallRequest(true)
                           setIsInstalling(false)
                        }, 1500)
                     }
                  }}
                  disabled={isInstalling}
               >
                  {onboardingData?.inboxAppInstallRequest ? (
                     <span className="flex items-center gap-3 animate-in fade-in zoom-in duration-500">
                        <CheckCircle02Icon className="w-6 h-6 text-[#00D492]" />
                        Installed
                     </span>
                  ) : isInstalling ? (
                     <span className="flex items-center gap-3">
                        <svg
                           className="w-6 h-6 animate-spin"
                           xmlns="http://www.w3.org/2000/svg"
                           fill="none"
                           viewBox="0 0 24 24"
                        >
                           <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                           ></circle>
                           <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                           ></path>
                        </svg>
                        Installing...
                     </span>
                  ) : (
                     <span className="flex items-center gap-3">
                        <img
                           src={InboxAppIcon}
                           alt="Inbox App"
                           className="w-6 h-6"
                        />
                        Install Inbox App
                     </span>
                  )}
               </Button>
            </Stack>
         </div>
      </Stack>
   )
}
